module.exports = __webpack_public_path__ + "static/media/DEGO-BNB.fb7c78d2.svg";